import { useContext, useMemo } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

import { APP_TITLE } from "../../Config/Environment";
import { FixtureDetailsContext } from "../../Config/FixtureDetails";
import PageDisplay from "../Base/PageDisplay/PageDisplay";
import { getTruncatedTeamName } from "../Base/Utilities/EntityUtilities";
import GameDetailsControls from "./GameDetailsControls";
import GameInfo from "./GameInfo";
import GameRules from "./GameRules";
import Officials from "./Officials";

import "./GameDetails.scss";

const GameDetails = ({ match, currentState }) => {
  const { competitors, errorMsg, hasLoaded, forceRefresh } = useContext(FixtureDetailsContext);

  const titles = useMemo(() => {
    const participants = [];
    if (competitors) {
      if (competitors[0].isHome) {
        participants.push(competitors[0], competitors[1]);
      } else {
        participants.push(competitors[1], competitors[0]);
      }
    }
    const participantsTitle = participants
      .filter((team) => !!team.nameFullLocal)
      .map((it) => getTruncatedTeamName(it.nameFullLocal, 32))
      .join(" v. ");
    const mainTitleBase = "Game Details";
    const page = [participantsTitle, mainTitleBase].filter((e) => !!e).join(" - ");
    const document = `${page} - ${APP_TITLE}`;
    return { document, page };
  }, [competitors]);

  return (
    <PageDisplay
      documentTitle={titles.document}
      pageTitle={titles.page}
      error={errorMsg}
      isLoading={!hasLoaded}
      reload={forceRefresh}
    >
      {hasLoaded && (
        <>
          <div className="game-details-container">
            <GameInfo />
            <GameRules />
            <Officials currentState={currentState} />
          </div>
          <GameDetailsControls />
        </>
      )}
    </PageDisplay>
  );
};

export default injectIntl(withRouter(GameDetails));
